import { render, staticRenderFns } from "./CarLabel.vue?vue&type=template&id=4ef6a9cc&scoped=true&"
import script from "./CarLabel.vue?vue&type=script&lang=js&"
export * from "./CarLabel.vue?vue&type=script&lang=js&"
import style0 from "./CarLabel.vue?vue&type=style&index=0&id=4ef6a9cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef6a9cc",
  null
  
)

export default component.exports